import { NgModule } from '@angular/core';
import { LazyLoadDirective } from './app-lazy-load';

@NgModule({
    declarations: [
      LazyLoadDirective
    ],
    exports: [
      LazyLoadDirective
    ]
})
export class LazyLoadModule { }